import { ReportsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useGetReportingFilter = () => {
  console.log("getting called");
  const [getReportingFilter] = useAPIAction(
    ReportsApi,
    async (api: ReportsApi, screenName: string) => {
      const data = await api.reportsGetUserFilter({ screenName: screenName });
      return { successMessages: [], data };
    },
    {
      translationPrefix: "",
    }
  );
  return useCallback(
    (screenName: string) => {
      return getReportingFilter(screenName);
    },
    [getReportingFilter]
  );
};
